import issues from "../data/featureRequests.json";
export function getFeatureRequests() {
    return issues;
}
